<vl-breadcrumb>
    <vl-breadcrumb-item
        :label="item.label"
        :to="item.disabled ? undefined : to(item)"
        :class="{ 'kl-breadcrumb__disabled': item.disabled }"
        v-for="(item, index) in breadcrumbs" :key="index">
        <span>{{ item.label }}</span>
    </vl-breadcrumb-item>
</vl-breadcrumb>

